
import createjs from 'createjs-module'

export class StrokedText extends createjs.Container{

    private _background: createjs.Shape | null = null;

    private _text1: createjs.Text;
    private _text2: createjs.Text;

    constructor(text: string, font: string, backgroundColor: string, frontColor: string){
        super()

        this._text1 = new createjs.Text(text, font, backgroundColor);
        this._text1.outline = 2;

        this._text2 = new createjs.Text(text, font, frontColor);

        let bgWidth = this._text1.getBounds().width * 1.8
        let bgHeight = this._text1.getBounds().height * 1.2
        this.initBackground('#ffffffff', bgWidth, bgHeight);

        this.addChild(this._text1)
        this.addChild(this._text2)

        // this.mouseEnabled = false;
        this.mouseChildren = false;

        this.setBounds(0, 0, bgWidth, bgHeight)

        this.updateLayout();
    }

    private initBackground(fillColor: string, width: number, height: number){
        this._background = new createjs.Shape();
        this._background!.graphics
            .beginFill(fillColor)
            .drawRect(0, 0, width, height)
            .endFill();

        // to have mouse interactivity the minimum alpha is 0.01
        this._background.alpha = 0.01

        // need to set setBounds otherwise getBounds will return null
        this._background!.setBounds(0, 0, width, height);

        this.addChild(this._background!)
    }

    private updateLayout(){
        
        let dimensions = this.getBounds();
        
        let bounds1 = this._text1.getBounds();
        let bounds2 = this._text2.getBounds();

        let yOffset = 3;
        this._text1.x = (dimensions.width - bounds2.width) * 0.5
        this._text1.y = (dimensions.height - bounds2.height) * 0.5 + yOffset

        this._text2.x = this._text1.x + (bounds1.width - bounds2.width) * 0.5
        this._text2.y = this._text1.y + (bounds1.height - bounds2.height) * 0.5
    }

    public set text(value: string){
        this._text1.text = value;
        this._text2.text = value;

        this.updateLayout();
    }

    public get text(){
        return this._text1.text;
    }

}